import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

export type Axis = 'x' | 'y' | 'z';

export default function AxisSelect({
  axis,
  onChange,
}: {
  axis: Axis;
  onChange: (axis: Axis) => void;
}) {
  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value as Axis);
  };

  return (
    <Box component="div">
      <FormControl fullWidth>
        <InputLabel>Achse</InputLabel>
        <Select value={axis} label="Achse" onChange={handleChange}>
          <MenuItem value={'x'}>X</MenuItem>
          <MenuItem value={'y'}>Y</MenuItem>
          <MenuItem value={'z'}>Z</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}
